import React, { useEffect } from "react";
import { Loader, Table, Icon } from "semantic-ui-react";
import { map, size, filter } from "lodash";
import moment from "moment";
import { HeaderPage, PrintHeader, PrintTable } from "../../components/Admin";
import { useCash, usePrintOrientation } from "../../hooks";
import { differenceText, differenceClass } from "./CashAdmin";
import "./CashAdmin.scss";

const amount = (value) => Number(value || 0).toFixed(2);
const time = (value) => (value ? moment.parseZone(value).format("DD/MM/YY HH:mm") : "—");

// Caja — "Cierres de caja": historial de turnos cerrados con lo esperado vs
// lo contado. Los totales salen de la foto guardada al cerrar
// (totals_snapshot), no se recalculan.
export function CashHistory() {
  const { loading, sessions, getCashSessions } = useCash();
  usePrintOrientation("landscape");

  useEffect(() => {
    getCashSessions();
  }, []);

  const closed = filter(sessions, (s) => s.closed_at);

  return (
    <>
      <div className="screen-only">
        <HeaderPage
          title="Caja — Cierres de caja"
          btnTitle={
            <>
              <Icon name="print" /> Imprimir
            </>
          }
          btnClick={() => window.print()}
        />
      </div>

      <PrintTable>
        <PrintHeader title="Cierres de caja" subtitle={`Al ${moment().format("DD/MM/YYYY")}`} />

        {loading ? (
          <Loader active inline="centered">
            Cargando...
          </Loader>
        ) : size(closed) === 0 ? (
          <p className="print-content">Todavía no hay cierres de caja.</p>
        ) : (
          <div className="print-content">
            <Table compact unstackable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Apertura</Table.HeaderCell>
                  <Table.HeaderCell>Cierre</Table.HeaderCell>
                  <Table.HeaderCell>Responsable</Table.HeaderCell>
                  <Table.HeaderCell textAlign="right">Inicial (S/)</Table.HeaderCell>
                  <Table.HeaderCell textAlign="right">Ventas (S/)</Table.HeaderCell>
                  <Table.HeaderCell textAlign="right">Esperado (S/)</Table.HeaderCell>
                  <Table.HeaderCell textAlign="right">Contado (S/)</Table.HeaderCell>
                  <Table.HeaderCell>Resultado</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {map(closed, (s) => (
                  <Table.Row key={s.id}>
                    <Table.Cell>{time(s.opened_at)}</Table.Cell>
                    <Table.Cell>{time(s.closed_at)}</Table.Cell>
                    <Table.Cell>
                      {s.closed_by_name || s.opened_by_name || "—"}
                      {s.notes && <div className="cash-admin__muted">{s.notes}</div>}
                    </Table.Cell>
                    <Table.Cell textAlign="right">{amount(s.opening_amount)}</Table.Cell>
                    <Table.Cell textAlign="right">
                      {amount(s.totals_snapshot?.total_sales)}
                    </Table.Cell>
                    <Table.Cell textAlign="right">{amount(s.expected_amount)}</Table.Cell>
                    <Table.Cell textAlign="right">{amount(s.counted_amount)}</Table.Cell>
                    <Table.Cell>
                      <span className={differenceClass(Number(s.difference))}>
                        {differenceText(Number(s.difference))}
                      </span>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
        )}
      </PrintTable>
    </>
  );
}
